import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {gsap, Power3} from "gsap";

const Container = styled.div`
    margin-bottom: 50px;
`;

const ContainerMovie = styled.div`
    overflow: hidden;
    /* height: calc((20vw + 100px) * 2.3); */
    transition: 0.6s ease-in-out;
    :not(:last-child){
        margin-bottom: 30px;
    }
    
    `;

const LoadMore = styled.button`
    width: 100%;
    height: 40px;
    background: rgba(255,255,255, 0);
    border: 2px solid rgba(255,255,255, 0.5);
    border-radius: 5px;
    margin: 0;
    padding: 0;
    overflow: visible;
    cursor: pointer;
    font-size: 15px;
    color: inherit;
    /* font: inherit; */
    transition: 0.1s ease-in-out;
    line-height: normal;
    &:hover{
        background: rgba(255,255,255, 0.1);
    }
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;
    -webkit-appearance: none;
    
`;


const Down = styled.div`
    width:100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.8s ease-in-out;
    
`;

const Title = styled.span`
    font-size: 17px;
    font-weight: 600;
    
`;

const Grid = styled.div`
    margin-top: 25px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 20px;
`;


const useLoadMore = () => {
    const [value, setValue] = useState(false);
    const load = useRef();
    const arrow = useRef();
    console.log(load.current);
    const changeLoad = () => {
        if(!value){
            setValue(true);
        }else{
            setValue(false);
        }
    }
    useEffect(() => {
        
        if(!value){
            gsap.from(".po", {x: 10000, duration: 1.5, opacity: 0, ease: Power3.easeOut},'Start')
            arrow.current.style.transform = "rotate(0deg)";
            load.current.style.height = "calc((10vw + 90px) * 2.3)";
        }else{
            gsap.from(".po", {x: 10000, duration: 1.5, opacity: 0, ease: Power3.easeOut},'Start')
            arrow.current.style.transform = "rotate(180deg)";
            load.current.style.height = "100%";
            // gsap.to(load.current, {css:{height: "100%"}, duration: 1, ease: Power3.easeInOut })

        }
    }, [value])

    return {arrow,load, changeLoad};
}



const Section = ({title, children}) => {
    const {arrow, load, changeLoad} =useLoadMore();
    return(
        <Container>
            <ContainerMovie ref={load}>
                <Title>{title}</Title>
                <Grid>{children}</Grid>
            </ContainerMovie>
            <LoadMore onClick={changeLoad}><Down ref={arrow}><i class="fa fa-chevron-down" aria-hidden="true"></i></Down></LoadMore>
        </Container>
    )};

Section.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node])
}
export default Section;